import { Link } from "react-router-dom";
import ProfileAvatar from "../common/avatar/ProfileAvatar";
import FreeBadge from "../common/badge/FreeBadge";
import WebinarHeroStatusBadge from "./WebinarHeroStatusBadge";

export default function HomeHeroSlideCard({
	href,
	external,
	imageUrl,
	title,
	subtitle = "",
	avatarUrl,
	date = "",
	showFreeBadge = false,
	showWebinarStatus = false,
	webinarStartDatetime = null,
	layout = "desktop",
}) {
	const isMobileLayout = layout === "mobile";
	const maxLen = 42;
	const displayTitle =
		(title ?? "").length > maxLen
			? `${title.slice(0, maxLen)}…`
			: title ?? "";

	const card = (
		<div
			className={[
				isMobileLayout
					? "relative w-full h-[220px] sm:h-[260px] rounded-[16px]"
					: "relative w-full h-[400px] md:h-[480px] rounded-[20px]",
				"overflow-hidden bg-[#1e293b]",
				"shadow-[0_16px_32px_-20px_rgba(15,23,42,0.22)]",
				"group-hover:shadow-[0_20px_36px_-18px_rgba(39,106,166,0.28)] transition-shadow",
			].join(" ")}
		>
			{showFreeBadge && (
				<FreeBadge className="absolute right-3 top-3 z-10" />
			)}
			{showWebinarStatus && (
				<WebinarHeroStatusBadge startDatetime={webinarStartDatetime} />
			)}

			{imageUrl ? (
				<img
					src={imageUrl}
					alt=""
					className="absolute inset-0 h-full w-full object-cover"
					loading="eager"
				/>
			) : (
				<div className="absolute inset-0 bg-gradient-to-br from-darkBlue to-[#1e3a5f]" />
			)}

			<div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />

			{displayTitle && (
				<div className="absolute inset-x-0 bottom-0 p-5 pt-12">
					<h3 className="line-clamp-2 font-Vazir-800 text-[18px] leading-snug text-white md:text-[22px]">
						{displayTitle}
					</h3>
					<div className="mt-3 flex items-center justify-between gap-2">
						<div className="flex min-w-0 items-center gap-2">
							<ProfileAvatar
								imageUrl={avatarUrl}
								name={subtitle || ""}
								size="sm"
								variant="onDark"
							/>
							<span
								className={[
									"truncate text-[13px] md:text-[14px]",
									subtitle
										? "font-Vazir-500 text-white/90"
										: "font-Vazir-400 text-white/55",
								].join(" ")}
							>
								{subtitle || "استاد ثبت نشده"}
							</span>
						</div>
						{date && (
							<span
								className="shrink-0 font-Vazir-400 text-[12px] text-white/75"
								dir="rtl"
							>
								{date}
							</span>
						)}
					</div>
				</div>
			)}
		</div>
	);

	const label = displayTitle || "بنر صفحه اصلی";
	const className = "block h-full w-full group";

	if (external) {
		return (
			<a href={href || "#"} aria-label={label} className={className}>
				{card}
			</a>
		);
	}

	return (
		<Link to={href || "#"} aria-label={label} className={className}>
			{card}
		</Link>
	);
}
